import PropTypes from 'prop-types'
import React from 'react';
import { StyleSheet, View, TouchableOpacity, TextInput, } from 'react-native';
import ENV from 'app/utils/ENV'
import Text from 'app/components/Text'
import apiActions from 'app/utils/apiActions'
import textHelpers from 'app/utils/textHelpers'
import { styleSheet, colors, sizes } from 'app/utils/styleSheet'
import TimelineNodes from 'app/components/TimelineNodes'

export default class RecursiveTimelineNodes extends React.Component {

  render(){
    return (
      <TimelineNodes {...this.props} />
    )
  }

}